<template>
  <div>
    <el-row>
      <el-col v-if="!train.name.includes('每日复习')" :span="1">
        <i @click="backToHome" class="el-icon-arrow-left back"></i>
      </el-col>
      <el-col :span="!train.name.includes('每日复习')?22:24" class="title">
        {{train.name}}
      </el-col>
    </el-row>
    
  </div>
</template>

<script>
export default {
  props: ['train'],
  methods: {
    backToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.back{
  font-size: 2.8em;
  margin: 15px 0 0 0;
}
.title{
  margin: 5px 0 0 0;
  font-size: 1.5em
}
</style>
